import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView } from "./analytics";

const TRACKED_PATHS = new Set(["/", "/careers"]);

export default function AnalyticsPageViews() {
  const location = useLocation();

  useEffect(() => {
    const pathname = location.pathname.replace(/\/$/, "") || "/";
    if (TRACKED_PATHS.has(pathname)) {
      trackPageView(pathname, location.search);
    }
  }, [location.pathname, location.search]);

  return null;
}
